import { createApiHandler } from './handler';

const productCategories = {
  apiClient: null,
  path: '/admin/product-categories',

  setClient(apiClient) {
    this.apiClient = apiClient;
    this.initApiHandler();
  },

  initApiHandler() {
    Object.assign(this, createApiHandler(this.apiClient, this.path));
  },
};

export default productCategories;
